import {
  ORGANIZATION_STICHTING,
  ORGANIZATION_UITGEKOOKT,
  ORGANIZATION_ZELFSTANDIG,
  SideBarItem
} from './types';

let options: Array<SideBarItem>;
options = [
  {
    icon: 'home',
    url: '',
    label: 'Home',
    excludeRoles: [],
    onlyShowForOrganizations: [],
    exact: true,
    next: true
  },
  {
    icon: 'team',
    url: 'klanten',
    label: 'Klanten',
    excludeRoles: ['distributor'],
    onlyShowForOrganizations: [],
    exact: false,
    next: false
  },
  {
    icon: 'user',
    url: 'profiel',
    label: 'Profiel',
    excludeRoles: ['distributor'],
    onlyShowForOrganizations: [],
    exact: false,
    next: true
  },
  {
    icon: 'calendar',
    url: 'afwezigheid',
    label: 'Afwezigheid',
    excludeRoles: ['distributor'],
    onlyShowForOrganizations: [],
    exact: false,
    next: false
  },
  {
    icon: 'calendar',
    url: 'inzetbaarheid',
    label: 'Inzetbaarheid',
    excludeRoles: ['distributor'],
    onlyShowForOrganizations: [],
    exact: false,
    next: false
  },
  {
    icon: 'deployment-unit',
    url: 'routes',
    label: 'Routes',
    excludeRoles: [],
    onlyShowForOrganizations: [],
    exact: false,
    next: false
  },
  {
    icon: 'table',
    url: 'invalroutes',
    label: 'Invalroutes',
    excludeRoles: [],
    onlyShowForOrganizations: [
      ORGANIZATION_UITGEKOOKT,
      ORGANIZATION_STICHTING,
      ORGANIZATION_ZELFSTANDIG
    ],
    exact: false,
    next: true
  },
  {
    icon: 'euro',
    url: 'betalingen',
    label: 'Betalingen',
    excludeRoles: ['distributor'],
    onlyShowForOrganizations: [],
    exact: false,
    next: true
  },
  {
    icon: 'message',
    url: 'maaltijdbeoordelingen',
    label: 'Maaltijdbeoordelingen',
    excludeRoles: ['distributor'],
    onlyShowForOrganizations: [],
    exact: false,
    next: true
  }
];

export default options;
